import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import deepBind from 'deep-bind-decorator';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import ResourcesComponent from './component';

export class ResourceContentModel extends BaseContentModel {
    
    static _slots = {
        icon: "",
        name: "",
        link: "",
    }

    static get _defaults() {
        return {
        }
    }
    
    @observable icon = "fa-file-pdf-o";
    @observable name = "Resource Name";
    @observable link = "/assets/resources/resource.pdf";
}

export class ResourcesContentModel extends BaseContentModel {
  
    static _slots = {
        title: "",
        resources: [ResourceContentModel],
    }

    static get _defaults() {
        return {
        }
    }

    constructor(props) {
        super(props);

    }

    Component = ResourcesComponent;

    @observable title = "Resources";
    @observable resources = [];

}
export default ResourcesContentModel



// WEBPACK FOOTER //
// ./app_modules/resources-activity/src/contentmodel.js